module.exports = __webpack_public_path__ + "aboutCover.3a86809f23e1e55b9077.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/aboutCover.jpg
// module id = ../../../../../src/assets/coverPicks/aboutCover.jpg
// module chunks = 0